


import React, { useState } from "react";
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toastStyles.css'; // custom toast styles
import "./Auth.css";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({
    identifier: '',
    password: '',
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const navigate = useNavigate();

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post("https://spinelleapi.emedha.in/user/auth/api/login", formData);
    toast.success(res.data.message || "Login successful");
    // localStorage.setItem("token", res.data.token);
    // After successful login
localStorage.setItem("token", res.data.token);
localStorage.setItem("user", JSON.stringify(res.data.user)); // if user data is sent
navigate('/profile');

  } catch (error) {
    toast.error(error.response?.data?.message || "Login failed");
  }
};


  return (
    <>
      <Header />
      <Navbar />
      <div className="auth-container">
        <div className="auth-card">
          <h2 className="auth-title">Welcome Back to Spinelle</h2>
          <p className="auth-subtitle mt-1">Luxury lives here. Let’s get you signed in.</p>
          <form onSubmit={handleSubmit}>
            <input type="text" name="identifier" placeholder="Email or Mobile Number" required onChange={handleChange} />
            <input type="password" name="password" placeholder="Password" required onChange={handleChange} />
            <button className="auth-btn" type="submit">Login</button>
            <p className="auth-link"><a href="#">Forgot Password?</a></p>
            <p className="auth-link">Don't have an account? <a href="/signup">Create One</a></p>
          </form>

          <div className="social-login">
            <p>Or continue with</p>
            <div className="social-icons1">
              <button
                className="social-icon-reset"
                style={{
                  backgroundColor: '#DB4437',
                  color: '#fff',
                  border: 'none',
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  fontSize: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  cursor: 'pointer',
                }}
              >
                <FaGoogle />
              </button>

              <button
                className="social-icon-reset"
                style={{
                  backgroundColor: '#3b5998',
                  color: '#fff',
                  border: 'none',
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  fontSize: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  cursor: 'pointer',
                }}
              >
                <FaFacebookF />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <HelpTrigger />
     <ToastContainer
  position="top-right"
  autoClose={4000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>

    </>
  );
};

export default Login;
